import Trash from './Trash.vue'

export default Trash
